import React, {useState} from 'react';
import {Button, Form} from "react-bootstrap";
import axios from 'axios';
import {API_ROOT, REGEX_EMAIL} from "../constants";
import {withGoogleReCaptcha} from "react-google-recaptcha-v3";

const styles = {
  border: '1px solid #333',
  borderRadius: '8px',
  background: '#f2f2f2'
}

const EmailCTA = ({googleReCaptchaProps}) => {
  const [email, setEmail] = useState('');
  const [emailCaptured, setEmailCaptured] = useState(false);
  const [invalidEmail, setInvalidEmail] = useState(false);

  const onSubmit = async () => {
    const isValid = REGEX_EMAIL.test(email.toLowerCase()) && email.toLowerCase().search('mailinator') === -1;
    if (!isValid) {
      setInvalidEmail(true);
      return;
    } else {
      setInvalidEmail(false);
    }

    const recaptchaValue = await googleReCaptchaProps.executeRecaptcha('75ideas');
    const headers = {
      'x-recaptcha': recaptchaValue
    };

    axios
      .post(`${API_ROOT}/create-free-account`,
        {
          email
        },
        {
          headers: {
            'Content-Type': 'application/json',
            ...headers
          }
        })
      .then(res => {
        setEmailCaptured(res.data.success);
      })
  }

  return <div className="col-10 col-md-6 mr-auto ml-auto mb-5 p-5 mt-5 mb-5" style={styles}>
    <div>
      <h4>Sign up for new ideas</h4>
      <p>We update this on a monthly basis</p>
    </div>
    <div className="row mt-3">
      {
        emailCaptured ?
          <div>We've signed you up!</div>
          :
          <React.Fragment>
            <Form.Control
              className="col-12 col-md-7 ml-auto mr-auto"
              placeholder="Email"
              aria-label="email"
              type="email"
              onChange={({target}) => setEmail(target.value)}
            />
            <Button
              className="col-12 mt-2 mt-md-0 col-md-4 ml-md-2 ml-auto mr-auto"
              onClick={onSubmit}
            >
              Receive new ideas
            </Button>
          </React.Fragment>
      }
    </div>
    {invalidEmail && <span>Oops, that's not a valid email</span>}
  </div>
}

export default withGoogleReCaptcha(EmailCTA);
